import axios from "axios";
import { GetAllNotificationFiltersDTO, GetAllNotificationDTO, NotificationDTO, NotificationsSianDTO } from "./dto";
import { NotificationService } from "./service";
import { keycloak } from "../../../lib/keycloak";

export class NotificationServiceImpl implements NotificationService {
    public LoadNotificationsFromFile(data: FormData): Promise<NotificationsSianDTO> {
        return axios.post("/api/notification/load-notifications-from-file",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllNotification(filters: GetAllNotificationFiltersDTO): Promise<GetAllNotificationDTO> {
        return axios.get("/api/notification", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                customerId: filters.customerId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetNotificationById(id: string): Promise<NotificationDTO> {
        return axios.get("/api/notification/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}